import Plugin from 'src/plugin-system/plugin.class';
import CookieStorage from 'src/helper/storage/cookie-storage.helper';

const storefrontAccessTokenKey = 'saasStorefrontAccessToken';

/**
 * @sw-package fundamentals@checkout
 */
export default class AccessTokenIframePlugin extends Plugin {

    static options = {
        canonicalDomain: '',
    };

    init() {
        this._registerEvents();
    }

    /**
     * register all needed events
     *
     * @private
     */
    _registerEvents() {
        window.addEventListener("message", (event) => {
            if (event.data.action !== 'saasCookieResponse') {
                return;
            }

            const cookieExisted = CookieStorage.getItem(storefrontAccessTokenKey) !== false;

            // Always update the cookie with a new
            CookieStorage.setItem(storefrontAccessTokenKey, event.data.value, 7);

            if (!cookieExisted) {
                // reload the page once if we have the new cookie set, so the page can use the new cookie
                // but don't reload if it already existed to prevent an infinite loop
                window.location.reload();
            }
        });
    }
}
